import { Component, OnInit, AfterViewInit, Renderer2, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { TranslateService } from '@ngx-translate/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from 'src/environments/environment';
import { AuthService } from '../shared/auth/auth.service';
import { Subscription } from 'rxjs';
import { CountdownService } from '../shared/countdown/countdown.service';

declare var NioApp: any;
declare var Swal: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements AfterViewInit, OnDestroy, OnInit {

  images = [
    'assets/images/wallpaper/wallpaper-1.jpg',
    'assets/images/wallpaper/wallpaper-2.jpg',
    'assets/images/wallpaper/wallpaper-3.jpg',
    'assets/images/wallpaper/wallpaper-4.png',
    'assets/images/wallpaper/wallpaper-5.jpg',
    'assets/images/wallpaper/wallpaper-6.jpg',
    'assets/images/wallpaper/wallpaper-7.jpg',
    'assets/images/wallpaper/wallpaper-8.jpg',
    'assets/images/wallpaper/wallpaper-9.jpg'
  ];

  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    margin: 10,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1,
        margin: 10
      },
      400: {
        items: 2,
        margin: 10
      },
      740: {
        items: 3,
        margin: 10
      },
      940: {
        items: 4,
        margin: 10
      }
    },
    nav: false
  };

  lang: string = '';
  mdcLink = environment.mdcLink;

  currentImage = this.images[0];
  private currentIndex = 0;
  private intervalDuration = 32000;
  private imageDuration = this.intervalDuration / this.images.length;
  private loadedImages: HTMLImageElement[] = [];

  status: string = '';
  remainingTime: string = '';
  prefixMessage: string = '';
  private subs = new Subscription();

  constructor(private router: Router,
    private translateService: TranslateService,
    private countdownService: CountdownService,
    private authService: AuthService) {
  }

  ngAfterViewInit(): void {
    NioApp.Stepper.init();
  }

  async ngOnInit(): Promise<void> {
    if (Capacitor.getPlatform() !== 'web') {
      if (!this.authService.isAuthenticated()) {
        this.router.navigate(['/login']);
      }
    }
    await this.preloadImages();
    this.startSlideshow();

    this.subs.add(
      this.countdownService.remainingTime$.subscribe(time => {
        this.remainingTime = time;
      })
    );

    this.subs.add(
      this.countdownService.prefixMessage$.subscribe(message => {
        this.prefixMessage = message;
      })
    );

    this.subs.add(
      this.countdownService.status$.subscribe(status => {
        this.status = status;
      })
    );

  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private preloadImages(): Promise<void[]> {
    const promises = this.images.map(image => {
      return new Promise<void>((resolve) => {
        const img = new Image();
        img.src = image;
        img.onload = () => {
          this.loadedImages.push(img);
          resolve();
        };
        img.onerror = () => resolve(); // Trata erro sem quebrar o fluxo
      });
    });
    return Promise.all(promises);
  }

  startSlideshow() {
    setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
      this.currentImage = this.images[this.currentIndex];
    }, this.imageDuration);
  }

  onLangClick() {
    if (this.lang) {
      localStorage.setItem('lang', this.lang);
      this.translateService.use(this.lang);
      this.router.navigate(['/mdc-form']);
    } else {
      Swal.fire({ title: null, text: "Escolha um idioma / Choose a language / Choisissez une langue", icon: "warning" });
    }
  }

  onGetStart() {
    this.router.navigate(['/mdc-form']);
  }
}